import '../assets/private/stylesheets/standalone/_standalone.less';
import './standalone/styles/style';


document.addEventListener('DOMContentLoaded', () => {
  if (cube.$('body.unsubscribe')) {
    import(/* webpackChunkName: "sa-unsubscribe" */ './standalone/sa-unsubscribe').then(
      ({initUnsubscribe}) => {
        initUnsubscribe();
      }
    );
  }

  if (cube.$id('delivery-method-reviews-cartridge')) {
    import(/* webpackChunkName: "delivery-mode-reviews" */ './standalone/delivery-mode-reviews').then(
      ({init}) => {
        init();
      }
    );
  }

  if (cube.$id('cp-iframe')) {
    import(/* webpackChunkName: "sa-helpcenter" */ './standalone/sa-helpcenter').then(
      ({init}) => {
        init();
      }
    );
  }

  if (cube.$('.cube-htc')) {
    import(/* webpackChunkName: "sa-htc" */ './standalone/sa-htc').then(
      ({init}) => {
        init();
      }
    );
  }

  if (cube.$id('contact-form'))
    import(/* webpackChunkName: "standalone-contact-form" */ './standalone/standalone-contact-form').then(
      ({init}) => {
        init();
      }
    );

  if (cube.$id('wechat-login'))
    import(/* webpackChunkName: "standalone-wechat-login" */ './standalone/standalone-wechat-login').then(
      ({init}) => {
        init();
      }
    );

  if (cube.$id('giftcard-balance-table'))
    import(/* webpackChunkName: "standalone-gift-card-history" */ './standalone/giftCardHistory').then(
      ({init}) => {
        init();
      }
    );

  if (cube.$id('qanda-script'))
    import(/* webpackChunkName: "standalone-question-answer" */ './standalone/questions-answers').then(
      ({ init }) => { init(); }
    );
});



// WEBPACK FOOTER //
// ./src/standalone.route.js